import React, { useEffect, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import StepOptions from '../header/StepOptions'
import AddToCart from '../modelController/AddToCart'
const ButtonNavigation = (props) => {
   const {
      setCurrentStepIndex,
      currentStepIndex,
      listData,
      basketState,
      formState,
      setFormState,
      validateCurrentOptionForm,
      setListData
   } = props
   const [previousDisabled, setPreviousDisabled] = useState(true)
   const [nextDisabled, setNextDisabled] = useState(false)

   useEffect(() => {
      const totalPages = listData.length
      setPreviousDisabled(currentStepIndex === 0)
      setNextDisabled(currentStepIndex === totalPages - 1)

   }, [currentStepIndex, listData])

   const handlePreviousClick = (event) => {
      currentStepIndex > 0 && setCurrentStepIndex(currentStepIndex - 1)
   }
   const handleNextClick = (event) => {
      const totalPages = listData.length
      currentStepIndex < totalPages - 1 && setCurrentStepIndex(currentStepIndex + 1)
   }
   return (
      <Row>
         <Col xs='12' className='d-flex justify-content-between py-1'>
            <Button variant='outline-dark rounded-0' size='sm' disabled={previousDisabled} onClick={handlePreviousClick}>
               previous
            </Button>
            <AddToCart setCurrentStepIndex={setCurrentStepIndex} basketState={basketState} listData={listData} formState={formState} />
            <Button variant='outline-dark rounded-0' size='sm' disabled={nextDisabled} onClick={handleNextClick} >
               Next
            </Button>
         </Col>
      </Row>
   )
}
export default ButtonNavigation